var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10143 0.154279C7.30696 -0.0512561 7.64014 -0.0512369 7.84569 0.154279C8.05124 0.359824 8.05124 0.692998 7.84569 0.898543L4.74459 3.99964L7.84569 7.10143L7.88201 7.14118C8.05071 7.34791 8.03842 7.65296 7.84569 7.84569C7.65296 8.03842 7.34791 8.05071 7.14118 7.88201L7.10143 7.84569L3.99964 4.74459L0.898542 7.84569C0.692997 8.05124 0.359823 8.05124 0.154278 7.84569C-0.0512381 7.64014 -0.0512571 7.30696 0.154278 7.10143L3.25469 3.99964L0.154278 0.898543L0.117956 0.858794C-0.0506838 0.652066 -0.0384283 0.346988 0.154278 0.154279C0.346987 -0.0384297 0.652064 -0.0506831 0.858793 0.117957L0.898542 0.154279L3.99964 3.25469L7.10143 0.154279Z",
    fill: "#004990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.b6eee5a5e65a3b697d9a413211f427f3.svg";
export { ForwardRef as ReactComponent };